import React from "react";
import { Helmet } from "react-helmet";

const Seo = ({ seo, pageImage = null, fallbackTitle = "Пак Пакыч" }) => {
    const s = seo ?? {};

    const title = s.seo_title || fallbackTitle;
    const description = s.seo_description || "";
    const keywords = s.seo_keywords || "";

    const ogTitle = s.og_title || title;
    const ogDescription = s.og_description || description;

    // Каскад og:image: og_image → seo_image → pageImage → ""
    const ogImage = s.og_image || s.seo_image || pageImage || "";

    // canonical: явный из админки или полный текущий URL (включая query params)
    const canonicalUrl = s.canonical_url || window.location.href;

    // robots
    const robotsParts = [];
    if (s.noindex) robotsParts.push("noindex");
    if (s.nofollow) robotsParts.push("nofollow");
    const robotsContent = robotsParts.length ? robotsParts.join(",") : "index,follow";

    return (
        <Helmet>
            <title>{title}</title>
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            <meta name="robots" content={robotsContent} />
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:locale" content="ru_RU" />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={ogTitle} />
            {ogDescription && <meta property="og:description" content={ogDescription} />}
            <meta property="og:url" content={window.location.href} />
            {ogImage && <meta property="og:image" content={ogImage} />}
        </Helmet>
    );
};

export default Seo;
